<template>
  <div v-if="!isDeleted">
    <li :class="{'u-font-bold':isNew}" class="list__item">
      <article class="cell cell--start">
        <div class="cell__media">
          <c-badge v-if="r.status === 2" v-tooltip="r.processing_messages" type="danger"></c-badge>
          <c-badge v-else-if="r.status === 1" type="success"></c-badge>
          <c-badge v-else></c-badge>
        </div>
        <div class="cell__content">
          <header :class="{'u-color-grey':!isNew}" class="cell__header">
            <div class="cell__leading">
              <div class="u-fs-14 i-text">
                <a :class="{'u-color-grey':!isNew}" href="#"
                   @click="downloadoriginal(r.id, r.displayname)"><span>{{ r.displayname }}</span></a>
                <span v-if="isInRole('admin')">&nbsp;&nbsp;<a href="#" @click="deleteRequest(r.id, r.displayname)"><i
                  class="icon-bin u-color-danger"></i></a></span>
                <span v-if="isNew">&nbsp;&nbsp;<i class="icon-new u-color-success"></i></span>
              </div>
            </div>
          </header>
          <div class="cell__body">
                <span v-if="r.properties != null">
                  <div class="u-mt-5">
                    <span v-for="p in Object.keys(r.properties)" :key="p">
                      <span v-if="hasProperty(p) && propertyIsVisible(p)">
                        <i class="u-fs-12 u-color-grey-light">{{ propertyLabel(p) }}:</i>&nbsp;
                        <span v-if="propertyIsEditable(p)"
                              class="u-fs-12 u-mr-15 u-color-grey-light u-color-grey-darkest"
                              style="border-bottom: 1px dotted; cursor: pointer"
                              @click="onEditProperty(p)">{{ propertyDisplayValue(r.properties[p]) }}</span>
                        <span v-if="!propertyIsEditable(p)"
                              class="u-fs-12 u-mr-15 u-color-grey-light u-color-grey-darkest">{{
                            propertyDisplayValue(r.properties[p])
                          }}</span>
                      </span>
                    </span>
                  </div>
                </span>
            <ul v-if="r.status == 1" class="list list--sm">
              <li v-for="a in r.artefacts" :key="a.id" class="list__item" style="border-top:0px">
                      <span class="i-text">
                        <a :class="{'u-color-grey':!isNew}" class="u-fs-12"
                           href="#" @click="downloadfile(a.request_id, a.id, r.displayname+a.namesuffix)"><span>{{
                            a.displayname
                          }}</span>&nbsp;<i
                          class="icon-download2 u-fs-12"></i></a>
                        <a v-if="r.status == 1" class="u-ml-10 u-fs-12" href="#" title="Correct data"
                           @click="patchData(a.request_id, a.id)"><i class="icon-spell-check u-color-success"></i></a>
                      </span>
              </li>
            </ul>
            <span v-if="r.status == 1 && r.artefacts.length == 0"
                  class="u-color-warning u-fs-12">Unrecognized file</span>
            <span v-if="r.status == 2" class="u-color-danger u-fs-12">{{ r.errormsg }}</span>
          </div>
        </div>
        <div class="cell__after" style="align-self: flex-start">
          <div style="display:flex;align-content: flex-end">
            <div>
              <div>{{ r.received_dt| formatDate }}<span v-if="r.user">&nbsp;/&nbsp;{{ r.user.name }}&nbsp;</span></div>
              <div class="u-font-normal" style="float: right"><i>{{ r.request_source_display }}</i></div>
            </div>
            <div>
              <a v-if="isNew" class="u-ml-10" href="#" title="Mark as READ" @click="markRead()"><i
                class="icon-checkmark u-color-success"></i></a>
              <a v-if="!isNew && r.status != 0" class="u-ml-10" href="#" title="Mark as UNREAD" @click="markUnread()"><i
                class="icon-checkmark2 u-color-success"></i></a>
              <i v-if="r.status == 0" class="icon-checkmark2 u-color-grey-light u-ml-10"></i>
            </div>
          </div>
        </div>
      </article>
      <PatchData ref="pd" :patches="patches"></PatchData>
      <FileUploadPropertyEdit ref="propEdit" @valueChanged="onPropertyValueChanged"></FileUploadPropertyEdit>
    </li>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import download from 'downloadjs'
import {mapState, mapGetters} from 'vuex'
import PatchData from './PatchData'
import FileUploadPropertyEdit from './FileUploadPropertyEdit'
import requests from '../services/request.service'

export default {
  props: ['request'],

  components: {
    FileUploadPropertyEdit,
    PatchData
  },

  data: function () {
    return {
      r: {
        id: this.request.id,
        displayname: this.request.displayname,
        errormsg: this.request.errormsg,
        artefacts: this.request.artefacts,
        received_dt: this.request.received_dt,
        user: {
          name: this.request.user.name
        },
        status: this.request.status,
        downloaded_dt: this.request.downloaded_dt,
        request_source_display: this.request.request_source_display,
        properties: this.request.properties,
        processing_messages: this.request.processing_messages
      },
      patches: []
    }
  },

  created () {
    let d = moment()
    let d1 = moment([d.year(), d.month(), d.date()])
    let d2 = d1.clone()
    // d2.add(1, 'd')
    this.endDate = d2
    this.startDate = d1
    this.role = window.sessionStorage.getItem('role')
  },

  computed: {
    ...mapState('auth', ['clientCode']),
    ...mapGetters('client', ['propertyLabel', 'propertyIsEditable', 'propertyIsVisible', 'hasProperty']),
    ...mapGetters('auth', ['isInRole']),
    isNew: function () {
      return (
        (this.r.status === 1 || this.r.status === 2) &&
        this.r.downloaded_dt == null
      )
    },
    isDeleted: function () {
      return this.r.status === -1
    }
  },

  methods: {
    downloadfile (requestid, id, filename) {
      let imageurl =
        process.env.API + this.clientCode + '/results/' + requestid + '/' + id
      this.downloadUrl(imageurl, filename)
    },

    deleteRequest: function (requestId, fileName) {
      this.$alert({
        type: 'warning',
        title: 'Warning',
        content: `Are you sure you want to delete this request - ${fileName}?`,
        showCancel: true,
        onConfirm: () => {
          // do something..
          // if you want to stop closing alert, just return false
          requests.deleteRequest(this.clientCode, requestId).then(data => {
            // this.$alert({
            //   type: 'success',
            //   content: 'Done',
            //   showCancel: false,
            //   confirmText: 'Close'
            // })
            this.r.status = -1
          })
            .catch(err => {
              console.error(err)
              this.$alert({
                type: 'error',
                content: 'Could not delete request',
                showCancel: false,
                confirmText: 'Close'
              })

            })
        },
        onCancel: () => {
          // do something..
          // if you want to stop closing alert, just return false
          return true
        }
      })
    },

    downloadoriginal: function (requestid, filename) {
      console.log('RequestId: ', requestid)
      let imageurl = process.env.API + this.clientCode + '/results/' + requestid
      this.downloadUrl(imageurl, filename)
    },

    propertyDisplayValue: function (value) {
      if (value == null || value.toString() === '') {
        return '(not set)'
      }

      return value
    },

    downloadUrl (url, filename) {
      let imageurl = url
      axios
        .get(imageurl, {
          responseType: 'blob'
        })
        .then(response => {
          download(response.data, filename)
        })
        .catch(reason => {
          console.error('Could not download file')
          console.error(reason)
          this.$alert({
            type: 'error',
            title: 'Could not download file',
            content:
              'The file you selected cannot be downloaded. It may have exceeded the retention period on the server or another error occured. You may want to contact the application administrators if you need more details.',
            showCancel: false,
            confirmText: 'Close'
          })
        })
    },

    markRead () {
      let imageurl = process.env.API + this.clientCode + '/results/read'
      let dt = new Date()
      axios.post(
        imageurl,
        {
          request: this.request.id
        })
        .then(response => {
          this.r.downloaded_dt = dt
          this.request.downloaded_dt = this.r.downloaded_dt
        })
        .catch(reason => {
          console.error('Could not mark request as READ')
          console.error(reason)
          this.$alert({
            type: 'error',
            title: 'Could not mark request as READ',
            showCancel: false,
            confirmText: 'Close'
          })
        })
    },

    markUnread () {
      let imageurl = process.env.API + this.clientCode + '/results/unread'
      axios.post(
        imageurl,
        {
          request: this.request.id
        }
      ).then(response => {
        this.r.downloaded_dt = null
        this.request.downloaded_dt = null
      })
        .catch(reason => {
          console.error('Could not mark request as READ')
          console.error(reason)
          this.$alert({
            type: 'error',
            title: 'Could not mark request as READ',
            showCancel: false,
            confirmText: 'Close'
          })
        })
    },

    patchData (requestId, artefactId) {
      let url = process.env.API + this.clientCode + '/' + requestId + '/' + artefactId + '/patches'
      axios.get(url,
        {
          headers: {
            Authorization: window.sessionStorage.getItem('token')
          }
        }
      ).then(response => {
        this.handlePatchDisplay(response.data, requestId, artefactId)
      }).catch(reason => {
        console.error('Could not get artefact patches')
        console.error(reason)
        this.$alert({
          type: 'error',
          title: 'Could not get artefact patches',
          showCancel: false,
          confirmText: 'Close'
        })
      })
    },

    handlePatchDisplay (data, requestId, artefactId) {
      this.patches = data
      this.$refs.pd.show(this.patches, requestId, artefactId)
    },

    onEditProperty (propertyCode) {
      this.$refs.propEdit.show(this.r.id, this.r.displayname, propertyCode, this.r.properties[propertyCode])
    },

    onPropertyValueChanged (propertyCode, propertyValue) {
      this.r.properties[propertyCode] = propertyValue
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DocumentRow.vue